import jQuery from 'jquery';

const $ = jQuery;

// slidesToShow tiers, checked from narrowest to widest; kept out of slick's
// own `responsive` option because slick's internal refresh (triggered by
// slickSetOption) re-derives slidesToShow from these breakpoints and would
// silently overwrite any manual reduction made by fitServiceSlidesToTitles
const SERVICE_SLIDER_BREAKPOINTS: Array<{ maxWidth: number; slidesToShow: number }> = [
  { maxWidth: 480, slidesToShow: 1 },
  { maxWidth: 767, slidesToShow: 2 },
  { maxWidth: 993, slidesToShow: 3 },
  { maxWidth: 1200, slidesToShow: 5 }
];
const SERVICE_SLIDER_DEFAULT_SLIDES_TO_SHOW = 6;

function baseServiceSlidesToShow(): number {
  const width = window.innerWidth;
  const tier = SERVICE_SLIDER_BREAKPOINTS.find( ( bp ) => width <= bp.maxWidth );
  return tier ? tier.slidesToShow : SERVICE_SLIDER_DEFAULT_SLIDES_TO_SHOW;
}

// if a service title wraps onto a second line at the current tier's
// slidesToShow, show one fewer slide (repeating until every title fits on
// one line, or only one slide is shown) instead of letting the title break
function fitServiceSlidesToTitles( $slider: JQuery ): void {
  const slick = $slider.slick( 'getSlick' );
  if ( !slick ) {
    return;
  }

  const titleWraps = (): boolean => {
    let wraps = false;
    $slider.find( '.slick-slide:not(.slick-cloned) .preview-title' ).each(
      function () {
        const lineHeight = parseFloat( getComputedStyle( this ).lineHeight );
        if ( lineHeight > 0 && this.offsetHeight > lineHeight * 1.5 ) {
          wraps = true;
        }
      }
    );
    return wraps;
  };

  let target = baseServiceSlidesToShow();
  if ( target !== slick.options.slidesToShow ) {
    $slider.slick( 'slickSetOption', 'slidesToShow', target, true );
  }

  let guard = 0;
  while ( target > 1 && titleWraps() && guard < 10 ) {
    target -= 1;
    $slider.slick( 'slickSetOption', 'slidesToShow', target, true );
    guard++;
  }
}

export function initServiceSlider(): void {
  const $slider = $( '.slider' );
  if ( !$slider.length ) {
    return;
  }

  $slider.slick(
    {
      slidesToShow: baseServiceSlidesToShow(),
      autoplay: false,
      infinite: true,
      arrows: true,
      dots: false,
      nextArrow: '<span class="button-icon__right button-icon-blue-white button-icon-hover-to-blue slick-next"></span>',
      prevArrow: '<span class="button-icon__left button-icon-blue-white button-icon-hover-to-blue slick-prev"></span>'
    }
  );

  fitServiceSlidesToTitles( $slider );

  // custom webfonts can still be loading at init time; the fallback font's
  // narrower glyphs may fit where the real font wraps, so re-check once
  // fonts have finished loading/swapping in
  document.fonts?.ready.then( () => fitServiceSlidesToTitles( $slider ) );

  let resizeTimeout: number;
  $( window ).on( 'resize', () => {
    window.clearTimeout( resizeTimeout );
    resizeTimeout = window.setTimeout( () => fitServiceSlidesToTitles( $slider ), 150 );
  } );
}
